<template>
  <a-modal
    :title="title"
    :width="c_width"
    v-model="c_visible"
    :maskClosable="false"
    :footer="null"
    :bodyStyle="c_bodyStyle"
    @cancel="cancel"
  >
    <slot name="modalBody"></slot>
  </a-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: ['title', 'width', 'visible', 'bodyStyle'],
  computed: {
    c_visible: {
      get: function () {
        return this.visible
      },
      set: function () {
      }
    },
    c_width: {
      get: function () {
        return this.width || 600
      },
      set: function () {

      }
    },
    c_bodyStyle: {
      get: function () {
        return this.bodyStyle || { background: '#fff' }
      },
      set: function () {

      }
    }
  },
  data () {
    return {
      // bodyStyle: {
      //   background: '#fff'
      // }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
